// extracted by mini-css-extract-plugin
export var assigneeBadge = "_n9-0";
export var assigneeDetails = "_n9-1";
export var assigneeInfo = "_n9-2";
export var dropdownContainer = "_n9-4";
export var dropdownImage = "_n9-5";
export var editAssigneeInfo = "_n9-3";
export var editAssigneeModalContainer = "_n9-6";
export var hidden = "_n9-8";
export var input = "_n9-7";